import axios from 'axios';
import { CNPJ } from '../config';


const api = axios.create({
    baseURL: 'https://apisiacweb.herokuapp.com/gestor/',
    headers: {
        Authorization: CNPJ, //CNPJ
    },    
});


export default api;
